import {InjectionToken, Provider} from '@angular/core';

export const TISA_SIGN_IN_URL_PATH = new InjectionToken<string>(
  'Provides path to sign in URL.',
);

export const TISA_SIGN_IN_URL_PROVIDERS: Provider[] = [
  {
    provide: TISA_SIGN_IN_URL_PATH,
    useValue: '/login',
  },
];
